import {prod} from '../config'

export const Config = {
    Url
}

function Url() : string {
    return prod ? "" : "https://localhost:7175" ;
}